import React from "react";
import C from "../../../constants";

export default function SignatureIcon({
  fill = C.TERTIARY_COLOR_0,
  className = "",
  ...props
}) {
  return (
    <React.Fragment>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        {...props}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.8228 2.83029C14.2709 2.77034 14.6439 2.80833 14.9166 2.86773C15.2719 2.9451 15.6153 3.09528 15.9226 3.25194C16.2638 3.42593 16.7248 3.70823 17.1217 4.12697C17.5246 4.55214 17.8855 5.14577 17.9444 5.91534C18.0033 6.68369 17.7516 7.50142 17.1696 8.3573C16.2141 9.76261 14.6873 10.5388 13.1788 10.9966C13.1874 10.9998 13.1961 11.0031 13.2049 11.0063C13.3935 11.0759 13.6459 11.0965 13.9454 11.0696C14.2424 11.043 14.5718 10.971 14.9056 10.8681C15.3378 10.735 15.7553 10.5595 16.1586 10.3494L16.2063 10.3246L16.26 10.327C16.4565 10.3359 16.6578 10.3506 16.8625 10.3899C17.0927 10.4341 17.4124 10.5175 17.7425 10.6779C18.4289 11.0114 19.2001 11.7157 19.2001 13V13.2H17.4753V13C17.4753 12.7738 17.4189 12.6219 17.3394 12.5117C17.2581 12.399 17.1407 12.3139 16.993 12.2421C16.8385 12.1671 16.6703 12.1214 16.5407 12.0962C16.2968 12.2083 15.8925 12.3804 15.4102 12.5289C14.6827 12.7531 13.5695 12.9908 12.6112 12.637C11.9197 12.3817 11.3287 12.0066 10.8913 11.498C9.22933 11.7407 7.67149 11.71 6.69304 11.6208L6.49419 11.6027L6.64906 9.87292L6.84855 9.89111C7.57927 9.95772 8.6915 9.98803 9.91425 9.86799C9.71341 9.45236 9.52991 8.97894 9.44032 8.46742C9.23969 7.32196 9.51121 6.07764 10.6316 4.79464C11.7909 3.46707 12.908 2.95271 13.8228 2.83029ZM13.997 4.15549C14.2758 4.11818 14.4945 4.14335 14.6372 4.17443C14.884 4.22819 15.1258 4.34343 15.3251 4.44508C15.5904 4.58035 15.9086 4.7811 16.1642 5.05088C16.4168 5.31736 16.5942 5.63502 16.6236 6.0184C16.653 6.40245 16.5391 6.92167 16.0772 7.601C15.1537 8.95923 13.431 9.63312 11.6572 10.0045L11.5149 10.0343L11.4426 9.90811C11.1416 9.38243 10.8517 8.84479 10.7449 8.23477C10.6203 7.52365 10.7482 6.68313 11.6255 5.67843C12.6094 4.55178 13.4494 4.22876 13.997 4.15549ZM1.91885 7.28432L3.50728 8.84095L5.09571 7.28432L6.29605 8.53151L4.74378 10.0527L6.29605 11.5739L5.09571 12.8211L3.50728 11.2645L1.91885 12.8211L0.718506 11.5739L2.27077 10.0527L0.718506 8.53151L1.91885 7.28432Z"
          fill={fill}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19 17H1.00005V15H19V17Z"
          fill={fill}
        />
      </svg>
    </React.Fragment>
  );
}
